import { createStoreContext } from "reusable/mobx-store-utils/storeUtils"
import MarkdownStore from "../../MarkdownStore"
import { PopoverPosition } from '../../popover/PopoverSurface'
import { RefObject } from "react"
import { MentionSelection, MentionUser } from "../../popover/MentionPopover"
import { colorKeyForUserId, isAvatarColor } from "../../popover/avatarColor"
import { makeAutoObservable } from 'mobx'

interface GapAssigneeStoreProps {
   attributes: Record<string, string> | undefined
   markdownStore: MarkdownStore
   updateMdastNode: (node: any) => void
   chipRef: RefObject<HTMLSpanElement>
}

export default class GapAssigneeStore {
   sp
   popover: { anchor: PopoverPosition; mode: 'mention' | 'date' } | null = null

   constructor(sp: GapAssigneeStoreProps) {
      makeAutoObservable(this)
      this.sp = sp
   }

   get team(): MentionUser[] {
      return this.sp.markdownStore.sp.users ?? []
   }

   get user() {
      return this.team.find(u => u.id === this.sp.attributes?.userId)
   }

   get userIsDeactivated() {
      return !!this.user?.deactivatedOn
   }

   get name() {
      return this.sp.attributes?.name || 'Unknown'
   }

   get colorKey() {
      const colorAttr = this.sp.attributes?.color
      return isAvatarColor(colorAttr) ? colorAttr : colorKeyForUserId(this.sp.attributes?.userId ?? '')
   }

   handleChipMouseDown = (event: React.MouseEvent) => {
      event.preventDefault()
      event.stopPropagation()
      const el = this.sp.chipRef.current
      if (!el) return
      const r = el.getBoundingClientRect()
      this.popover = { anchor: { left: r.left, top: r.top, bottom: r.bottom }, mode: 'mention' }
   }

   handleDatePicked = (date: string) => {
      this.sp.updateMdastNode({
         name: 'GapDate',
         attributes: { date },
      })
      this.popover = null
   }

   handleSelect = (selection: MentionSelection) => {
      if (selection.kind === 'user') {
         this.sp.updateMdastNode({
            attributes: { userId: selection.userId, name: selection.name, color: selection.colorKey },
         })
         this.popover = null
      } else if (selection.kind === 'date') {
         this.sp.updateMdastNode({
            name: 'GapDate',
            attributes: { date: selection.iso },
         })
         this.popover = null
      } else {
         if (this.popover) {
            this.popover.mode = 'date'
         }
      }
   }

   handleClose = () => {
      this.popover = null
   }

}

export const { Provider: GapAssigneeStoreProvider, useProvidedStore: useGapAssigneeStore } = createStoreContext(GapAssigneeStore)
